/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react/no-multi-comp */
/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash.isempty';

import { useInView } from 'react-intersection-observer';

import { Heading4 } from 'app/shared/ui';
import {
  ReducedPriceCartilesWrapperSt,
  LinkButtonSt,
  LoadingContainerSt,
  ReducedPriceCartilesContainerSt,
} from 'app/marketplace/home/ReducedPriceCars/ReducedPriceCars.css';
import { CarouselSt } from 'app/marketplace/moreLikeThisListings/MoreLikeThisListingsCarousel/MoreLikeThisListingsCarousel.css';
import { trackAction } from 'app/shared/utils/tracking';
import { LoadingSpinner } from 'app/shared/components/LoadingSpinner/LoadingSpinner';
import {
  IReducedPriceCars,
  ICustomNavArrow,
} from 'app/marketplace/home/ReducedPriceCars/ReducedPriceCars.type';
import { GetCartileData } from 'app/shared/modules/Cartile/CartileWebApp';
import { isFavourite } from 'app/shared/utils/vehicle';
import { IVehicle } from 'app/types/entities/Vehicle.types';
import { useInitialMount } from 'app/shared/hooks/useInitialMount';

import { defaultVehicleListSizeMap, handleCTATracking } from './utils';

/* istanbul ignore next */
export const CustomNavArrow = ({
  direction,
  className,
  ...rest
}: ICustomNavArrow): JSX.Element => (
  <div className={className}>
    <i className={`if-icon-arrow-${direction}`} {...rest} />
  </div>
);
/* Keeping this here to avoid styled-component error */
export const NavArrowSt = styled(CustomNavArrow)`
  width: 64px;
  height: 64px;
  background: white;
  i {
    color: #164ca3;
    font-size: 35px;
    margin-top: 15px;
    text-align: center;
  }
  &.slick-disabled {
    i {
      color: #c1c1c1;
    }
  }
  &.slick-arrow {
    top: -110px;
  }
  &.slick-arrow.slick-prev {
    right: 64px;
  }
`;

export const ReducedPriceCars = ({
  getReducedCars,
  breakpoint,
  reducedPriceVehicles,
  isLoading,
  performanceUnit,
  budgetRangeValue,
  toggleFavourite,
  currentLocation,
  favouriteIds,
  deviceType,
}: IReducedPriceCars): JSX.Element => {
  const pageViewRef = useRef<number[]>([]); // For storing already viewed vehicles.
  const isInitialMount = useInitialMount();
  const [reducedCarsRef, reducedCarsInView] = useInView({
    triggerOnce: true,
    rootMargin: '0px 0px',
  });
  const vehicleIds = useMemo(
    () => reducedPriceVehicles.map((vehicle: IVehicle) => vehicle.id),
    [reducedPriceVehicles],
  );
  const isMobile = deviceType === 'mobile';
  useEffect(() => {
    const numberOfVehicles = deviceType === 'mobile' ? 3 : 10;
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getReducedCars(numberOfVehicles);
  }, []);

  useEffect(() => {
    // Tracking page 1 data when section is visible
    if (!isInitialMount && !isMobile) {
      const vehicleCount = breakpoint === 'md' ? 2 : 3;
      trackAction('carousel_pagination_button_click', {
        category: 'home',
        label: 'page 1',
        value: [...vehicleIds].splice(0, vehicleCount),
      });
      pageViewRef.current.push(1);
    }
  }, [reducedCarsInView]);

  const slidesToShow = defaultVehicleListSizeMap[breakpoint];
  const isResultsLessThanSlidesToShow =
    reducedPriceVehicles?.length <= slidesToShow;

  return (
    <ReducedPriceCartilesWrapperSt ref={reducedCarsRef}>
      {isLoading ? (
        <LoadingContainerSt>
          <LoadingSpinner type="black" size={124} itemSize={10} />
        </LoadingContainerSt>
      ) : (
        <ReducedPriceCartilesContainerSt>
          <Heading4
            as="h2"
            mb={[40, 56, 64]}
            mt={[40, 56, 64]}
            ml={[15, 0]}
            fontWeight="800"
            fontSize={[24, 28, 32]}
          >
            Aktuelle Sonderangebote
          </Heading4>
          <CarouselSt
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            isMobile={isMobile}
            slidesToShow={
              isResultsLessThanSlidesToShow
                ? reducedPriceVehicles.length
                : slidesToShow
            }
            centerMode={false}
            slidesToScroll={slidesToShow}
            isCarouselReady
            infinite={false}
            showArrows={!isMobile}
            prevArrow={<NavArrowSt direction="left-long" />}
            nextArrow={<NavArrowSt direction="right-long" />}
            isResultsLessThanSlidesToShow={isResultsLessThanSlidesToShow}
            lazyLoad="ondemand"
            afterChange={
              /* istanbul ignore next */ (currentSlide: number) => {
                const pageNo =
                  currentSlide / defaultVehicleListSizeMap[breakpoint] + 1;
                if (pageViewRef.current.indexOf(pageNo) === -1) {
                  const vehicleCount = breakpoint === 'md' ? 2 : 3;
                  trackAction('carousel_pagination_button_click', {
                    category: 'home',
                    label: `page ${pageNo}`,
                    value: [...vehicleIds].splice(currentSlide, vehicleCount),
                  });
                  pageViewRef.current.push(pageNo);
                }
              }
            }
          >
            {reducedPriceVehicles.map((vehicle, index) => {
              const { CartileContainer, props } = GetCartileData({
                index,
                vehicle,
                isLoading,
                breakpoint,
                width: [1],
                target: 'home',
                isLazy: true,
                performanceUnit,
                budgetRangeValue,
                toggleFavourite,
                isHorizontal: false,
                additionalTrackingOptionData: {
                  label: 'reduced_price',
                },
                isFavourite: isFavourite(favouriteIds, vehicle.id),
                currentLocation: isEmpty(currentLocation)
                  ? null
                  : currentLocation,
              } as any);
              return (
                <div key={vehicle.id}>
                  <CartileContainer {...props} />
                </div>
              );
            })}
          </CarouselSt>
          <LinkButtonSt
            to="/gebrauchtwagen?specialOffers=reducedPrice"
            onClick={handleCTATracking}
          >
            Alle Sonderangebote anzeigen
          </LinkButtonSt>
        </ReducedPriceCartilesContainerSt>
      )}
    </ReducedPriceCartilesWrapperSt>
  );
};
